import type { ApplicationSettingAuthenticationField, FieldCellValue } from '@lighthouse/core'
import { CellValue } from 'exceljs'

export type AppLoginMode = 'mobileLogin' | 'home' | 'emailLogin' | 'weChatLogin' | 'bindMobile' | 'perfect' | 'bindEmail' | 'bindWechat'
export interface AppModeProperty {
    title: string
    catLeft: number
}

export type PerfectFieldItem = { value: FieldCellValue } & ApplicationSettingAuthenticationField

export enum LoginAuthType {
    mobile = 1,
    email,
    wechat,
    pc_wechat,
    google,
    follow_wechat = 7,
    miniProgram
}

export interface AccountRegisterForm {
    mobile: string
    email: string
    code: string
    authType: LoginAuthType
}

export interface AccountLoginForm {
    mobile: string
    email: string
    code: string
    groupId?: string
    fields: PerfectFieldItem[]
    authType: LoginAuthType
}

export interface AccountBindMobileForm {
    mobile: string
    code: string
}

export interface AccountBindAccountForm {
    account?: string
    code: string
    type?: LoginAuthType
}

export interface AccountMergeAccount {
    isLoggedInAccount: boolean
    mobile: string
}
export type SendCodeType = 'email' | 'mobile'

export interface AccountPerfectForm {
    roleId?: string
    fields: PerfectFieldItem[]
}

export enum BindMobileResultStatus {
    'SUCCESS' = 'SUCCESS',
    'PHONE_BOUND' = 'PHONE_BOUND',
    'COMBINED_ACCOUNT' = 'COMBINED_ACCOUNT'
}

export type BindMobileResult = {
    status: BindMobileResultStatus
    name: string
    uniqueUserId: string
    userId: string
    openId?: string
    accessToken?: string
    refreshToken?: string
}
